import { UserLogin } from 'src/types'

export const login = (payload: UserLogin) => ({ type: 'user/login', payload })
export const logout = () => ({ type: 'user/logout' })
